import { Examen } from '../types/examenes';
import httpClient from './httpClient';

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  totalPages: number;
}

export interface FetchExamenesParams {
  page?: number;
  limit?: number;
  search?: string;
  categoria?: string;
}

export const fetchExamenes = async (params?: FetchExamenesParams): Promise<PaginatedResponse<Examen>> => {
  const response = await httpClient.get('/api/examenes', { params });

  const r = response.data;

  // New paginated format: { data, total, page, totalPages }
  if (r && Array.isArray(r.data) && typeof r.total === 'number') {
    return r as PaginatedResponse<Examen>;
  }

  // Legacy format: directly an array → wrap in paginated shape
  if (Array.isArray(r)) {
    return { data: r, total: r.length, page: 1, totalPages: 1 };
  }

  // Unexpected
  console.warn('Estructura de respuesta inesperada en fetchExamenes:', r);
  return { data: [], total: 0, page: 1, totalPages: 0 };
};

export const createExamen = async (examenData: Omit<Examen, '_id'>): Promise<Examen> => {
  const response = await httpClient.post('/api/examenes', examenData);
  return response.data;
};

export const updateExamen = async (id: string, examenData: Omit<Examen, '_id'>): Promise<Examen> => {
  const response = await httpClient.put(`/api/examenes/${id}`, examenData);
  return response.data;
};

export const deleteExamen = async (_id: string): Promise<void> => {
  await httpClient.delete(`/api/examenes/${_id}`);
};

export const exportExamenes = async (): Promise<any[]> => {
  const response = await httpClient.get('/api/examenes/export');
  return response.data;
};

export interface ImportResult {
  created: number;
  skipped: number;
  errors: string[];
}

export const importExamenes = async (examenes: any[]): Promise<ImportResult> => {
  const response = await httpClient.post('/api/examenes/import', { examenes });
  return response.data;
};